import React, { useCallback, useState, useRef, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDropzone } from 'react-dropzone';
import Popover from 'react-bootstrap/Popover';
import Overlay from 'react-bootstrap/Overlay';
import Modal from 'react-bootstrap/Modal';
import Spinner from 'react-bootstrap/Spinner';
import { s3Link } from '../utils/constants';

import Croppie from 'croppie';
import "croppie/croppie.css";
import Avatar from './Avatar';
import { connect, useDispatch } from 'react-redux';
import { setAlert, setUser } from '../../redux/actions';
import CloseButton from './CloseButton';

const ProfileUploader = ({ getUserInformation, user }) => {

    const dispatch = useDispatch();

    const [croppie, setCroppie] = useState("");
    const [isProfileLoading, setIsProfileLoading] = useState(false);
    const [profile, setProfile] = useState('');
    const [profileObj, setProfileObj] = useState('');

    // const userInformation = JSON.parse(localStorage.getItem('user'));
    const [show, setShow] = useState(false);
    const [error, setError] = useState('');
    const [file, setFile] = useState(null);
    const [checkAvatar, setCheckAvatar] = useState(0);

    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
        setCroppie("");
    };

    const onDropRejected = useCallback(() => {
        setError('Only .jpg, .jpeg, .png files are accepted');
    }, []);

    const onDropAccepted = useCallback((acceptedFiles) => {
        setError('');
        setProfile(acceptedFiles[0]);
        setProfileObj(URL.createObjectURL(acceptedFiles[0]));
        upload(acceptedFiles[0]);
    }, []);

    const {
        getRootProps,
        getInputProps,
        isDragActive,
    } = useDropzone({
        onDropRejected,
        onDropAccepted,
        accept: 'image/jpeg, image/png',
        maxFiles: 1,
        multiple: false,
    });

    const upload = async (payload) => {
        setIsProfileLoading(true);
        const formData = new FormData();
        formData.append('profile_pic', payload);

        if (file) {
            formData.append('profile_logo', file);
        }

        await axios.post(
            `/api/users/${localStorage.getItem('loggedin_user')}`,
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            },
        )
            .then((response) => {
                // location.reload();

                dispatch(setUser());
                dispatch(setAlert({
                    show: true,
                    type: 'success',
                    body: 'Profile photo updated'
                }));

                $('#dropdown-avatar .shadow-sm')
                    .html(`<img src="${URL.createObjectURL(payload)}" width="50" height="50" />`);
                $('#header-avatar .shadow-sm')
                    .html(`<img src="${URL.createObjectURL(payload)}" width="50" height="50" />`);

                $('#dropdown-avatar')
                    .css({
                        border: '2px solid #0097fe'
                    });

                setIsDefaultAvatar(false);
                setIsProfileLoading(false);

                setCheckAvatar(checkAvatar => checkAvatar + 1);
            })
            .catch((error) => {
                setIsProfileLoading(false);
                dispatch(setAlert({
                    show: true,
                    type: 'error',
                    body: 'Unable to update profile photo'
                }));
            });
    };


    const handleCroppie = (image) => {
        var el = document.getElementById("image-helper");
        if (el) {
            var croppieInstance = new Croppie(el, {
                enableExif: true,
                boundary: {
                    height: 280
                },
                background: false,
                viewport: { width: 250, height: 250, type: 'circle' },
                enableOrientation: true
            });

            croppieInstance.bind({
                url: image,
                orientation: 1
            });

            setCroppie(croppieInstance);
        }
    };

    const [popShow, setPopShow] = useState(false);
    const [target, setTarget] = useState(null);
    const ref = useRef(null);

    const handlePopShow = (event) => {
        setPopShow(!popShow);
        setTarget(event.target);
    };


    const uploadChange = (event) => {
        const type = event.target.files[0].type;
        if (type.indexOf('image') < 0) {
            setError('Only .jpg, .jpeg, .png files are accepted');
            return;
        }
        setFile(event.target.files[0]);
        handleCroppie(URL.createObjectURL(event.target.files[0]));
    };

    const handleCropUpload = () => {
        croppie.result({
            type: 'blob',
            size: {
                width: 400,
                height: 400
            },
            format: 'png',
            quality: 1
        }).then(function (blob) {
            setProfileObj(URL.createObjectURL(blob));
            upload(blob);
        });
    };

    const handleRemovePorfilePic = async () => {
        setIsProfileLoading(true);
        await axios.post(`/api/users/${localStorage.getItem('loggedin_user')}`, {
            action: 'remove_profile_picture'
        })
            .then((response) => {
                setIsProfileLoading(false);

                setProfileObj('');
                getUserInformation();
                dispatch(setAlert({
                    show: true,
                    type: 'success',
                    body: 'Profile photo updated'
                }));

                setIsDefaultAvatar(user.profile_pic);

                $('#dropdown-avatar').html(`
                    <div
                        class="shadow-sm"
                        style="
                            width: 50px;
                            height: 50px;
                            font-size: 50px;
                            color: #0097FE;
                            border-radius: 50%;
                            background-color: #fff;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                        "
                    >
                                <i class="fa-solid fa-circle-user"></i>
                            </div>
                `);

                // setAvatar(DefaultAvatar)
            }).catch(error => {
                setIsProfileLoading(false);
                dispatch(setAlert({
                    show: true,
                    type: 'error',
                    body: 'Unable to process request'
                }));
            });
    };

    const [avatar, setAvatar] = useState('');
    const [isDefaultAvatar, setIsDefaultAvatar] = useState(true);

    useEffect(() => {
        if (user && Object.keys(user).length > 0) {
            const avatarValue = user.profile_pic ? `${s3Link}/${user.id}/profile_photo.jpg?t=${Date.now()}` : false;
            setAvatar(avatarValue);
            // setIsDefaultAvatar(!!avatarValue);
        }
    }, [user]);

    useEffect(() => {
        setIsDefaultAvatar(!!!avatar);
    }, [avatar]);

    return (
        <>
            <Modal className="prof-uploader text-center" show={show} onHide={handleClose} centered>
                <Modal.Header>
                    <CloseButton
                        className="close"
                        onClick={handleClose}
                        style={{ position: 'absolute', top: '12px', right: 0 }}
                    />
                    <Modal.Title><b>Position and size your photo</b></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div id="image-helper"></div>
                    {croppie === "" && <div>
                        <span className="icon">
                            <FontAwesomeIcon icon={['fas', 'camera']} />
                        </span>
                        <span className="str">
                            Upload your photo here
                            <small className="um-max-filesize">( max: <span>10MB</span> )</small>
                        </span>
                        <div className="upload">
                            <input id="prof-upload" onChange={uploadChange} type="file" accept="image/jpeg, image/png" />
                            <button className="btn theme-btn theme-btn-bordered">Upload</button>
                        </div>

                        {error && <div className="mt-3 text-danger">{error}</div>}
                    </div>}
                    {croppie !== "" &&
                        <div className="prof-uploader-btns">
                            <div className="prof-uploader-btns-wrapper">
                                <button onClick={handleClose} className="btn theme-btn theme-btn-white theme-btn-bordered">Cancel</button>
                                <button onClick={() => { handleCropUpload(); handleClose(); }} className="btn theme-btn theme-btn-bordered">Save</button>
                            </div>
                        </div>
                    }
                </Modal.Body>
            </Modal>
            <Overlay show={popShow} target={target} placement="bottom" container={ref.current}
                containerPadding={20}>
                <Popover id="popover-basic" className="prof-overlay">
                    <Popover.Content>
                        <ul onClick={handlePopShow}>
                            <li onClick={handleShow}><a>{isDefaultAvatar ? 'Upload profile photo' : 'Change profile photo'}</a></li>
                            {!isDefaultAvatar &&
                                <li onClick={handleRemovePorfilePic}><a>Remove photo</a></li>
                            }
                            <li><a>Cancel</a></li>
                        </ul>
                    </Popover.Content>
                </Popover>
            </Overlay>
            <div
                className="profile-image-holder"
                {...getRootProps()} onClick={handlePopShow}
            >
                {avatar ? <img src={avatar} /> : <Avatar size="94" story={false} />}
                {
                    isProfileLoading ? (
                        <Spinner animation="border" role="status" size="sm" variant="primary">
                            <span className="sr-only">Uploading...</span>
                        </Spinner>
                    )
                        : <FontAwesomeIcon icon={['fas', 'camera']} />
                }
            </div>
        </>
    );
};

const mapStateToProps = state => {
    return {
        user: state.user.user
    };
};

export default connect(mapStateToProps)(ProfileUploader);
